import type { Resource } from '../../';
export const search_box_frame_close: Resource = {"default":"Close Search"};
